<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1 v-if="!editStatus">
        เพิ่มรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <h1 v-if="editStatus">
        แก้ไขรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active" v-if="!editStatus">เพิ่มรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่</li>
        <li class="active" v-if="editStatus">แก้ไขรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <!-- <div class="box-header with-border">
                <h3 class="box-title"></h3>
              </div> -->

              <div class="row">
                <div class="col-sm-12">
                  <div class="col-sm-12">
                  <el-steps
                    :active="active"
                    finish-status="success"
                    style="margin-top: 19px"
                    simple
                  >
                    <el-step title="ขั้นตอนที่ 1" class="btn-step" @click.native="steps(0)"></el-step>
                    <el-step title="ขั้นตอนที่ 2" class="btn-step" @click.native="steps(1)"></el-step>
                    <el-step title="ขั้นตอนที่ 3" class="btn-step" @click.native="steps(2)"></el-step>
                    <el-step title="ขั้นตอนที่ 4" class="btn-step" @click.native="steps(3)"></el-step>
                    <el-step title="ขั้นตอนที่ 5" class="btn-step" @click.native="steps(4)"></el-step>
                    <el-step title="ขั้นตอนที่ 6" class="btn-step" @click.native="steps(5)"></el-step>
                    <el-step title="ขั้นตอนที่ 7" class="btn-step" @click.native="steps(6)"></el-step>
                    <el-step title="ขั้นตอนที่ 8" class="btn-step" @click.native="steps(7)"></el-step>
                    <el-step title="ขั้นตอนที่ 9" class="btn-step" @click.native="steps(8)"></el-step>
                  </el-steps>
                  </div>
                </div>
                <div class="col-sm-12">
                    <el-form
                      size="small"
                      :label-position="label_position"
                      label-width="100px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div v-if="active===0" class="col-sm-12">
                        <el-form-item label="รหัสรายการส่งเสริมการขาย" required>
                          <el-input clearable v-model="form.promotion_code" show-word-limit maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="ชื่อรายการส่งเสริมการขาย (ภาษาไทย)" required>
                          <el-input
                            clearable
                            v-model="form.promotion_name_th"
                            show-word-limit
                            maxlength="200"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)">
                          <el-input
                            clearable
                            v-model="form.promotion_name_en"
                            show-word-limit
                            maxlength="200"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="ประเภทบริการของรายการส่งเสริมการขาย" required>
                          <el-select v-model="form.promotion_category" filterable>
                            <el-option label="ระบบเติมเงิน (Prepaid)" value="Prepaid"></el-option>
                            <el-option label="ระบบรายเดือน (Postpaid)" value="Postpaid"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="ชนิดของรายการส่งเสริมการขาย"
                          required
                        >
                          <el-select v-model="form.promotion_type" filterable @change="pickType()">
                            <el-option label="รายการส่งเสริมการขายหลัก (Main)" value="Main"></el-option>
                            <el-option label="รายการส่งเสริมการขายเสริม (On-top)" value="on-top"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="จำนวนวันการให้บริการของรายการส่งเสริมการขายเสริม (เฉพาะ On-Top)" prop="number_of_service_days" >
                          <el-input-number :disabled="form.promotion_type !== 'on-top'" v-model="form.number_of_service_days" :precision="2" :step="1" :max="1000" :min="null" style="width: 220px"></el-input-number>
                        </el-form-item>
                        <el-form-item label="ระยะเวลา"></el-form-item>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="เริ่มต้นของการเสนอขาย" required>
                              <el-date-picker
                                style="width:100%;"
                                v-model="form.start_sale_date"
                                type="date"
                              ></el-date-picker>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="สิ้นสุดของการเสนอขาย">
                              <el-date-picker
                                style="width:100%;"
                                v-model="form.end_sale_date"
                                type="date"
                              ></el-date-picker>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="เริ่มต้นของการให้บริการ" required>
                              <el-date-picker
                                v-model="form.start_service_date"
                                type="date"
                                style="width:100%;"
                              ></el-date-picker>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="สิ้นสุดของการให้บริการ">
                              <el-date-picker
                                v-model="form.end_service_date"
                                type="date"
                                style="width:100%;"
                              ></el-date-picker>
                            </el-form-item>
                          </div>
                        </div>
                        <el-form-item label="สถานะการให้บริการ" required>
                          <el-select v-model="form.service_status" style="width:220px;">
                            <el-option label="(S) เฉพาะรายการส่งเสริมการขายใหม่ (ยังขายอยู่)" value="S"></el-option>
                            <el-option label="(U) ไม่ขายแล้วแต่ยังให้บริการอยู่" value="U"></el-option>
                            <el-option label="(X) ยกเลิกการให้บริการแล้ว" value="X"></el-option>
                            <el-option label="(CS) Corporate (ยังขายอยู่)" value="CS"></el-option>
                            <el-option label="(CU) Corporate (ไม่ขายแล้วแต่ยังให้บริการอยู่)" value="CU"></el-option>
                            <el-option label="(CX) Corporate (ยกเลิกการให้บริการแล้ว)" value="CX"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="ค่าบริการเหมาจ่ายรวมตามสิทธิ์การใช้งาน (บาท)" prop="promotion_price">
                          <el-input-number v-model="form.promotion_price" :precision="2" :step="10" :max="100000000" :min="null" style="width: 220px"></el-input-number>
                        </el-form-item>
                        <router-link to="/Operator/Manage_mobile" style="margin-top: 12px;margin-bottom: 12px;float: left;">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            >ยกเลิก
                        </button>
                        </router-link>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                      <!-- Total fee according to the usage rights (tfattur) -->
                      <div v-if="active===1" class="col-sm-12">
                        <el-form-item label="ค่าบริการจำแนกตามประเภทบริการ (บาท)"></el-form-item>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="บริการเสียง (บาท)" prop="voice_service" >
                              <el-input-number v-model="form.voice_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="บริการ SMS (บาท)" prop="sms_service" >
                              <el-input-number v-model="form.sms_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="บริการ MMS (บาท)" prop="mms_service" >
                              <el-input-number v-model="form.mms_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="บริการ Internet (บาท)" prop="internet_service">
                              <el-input-number v-model="form.internet_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="WiFi (บาท)" prop="wifi_service">
                              <el-input-number v-model="form.wifi_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="Others" prop="other_service">
                              <el-input-number v-model="form.other_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                            </el-form-item>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>

                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                      <div v-if="active===2" class="col-sm-12">
                      <el-form-item label="สิทธิ์การใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ"></el-form-item>
                        <div class="col-sm-4">
                          <el-form-item label="บริการเสียง (นาที)">
                            <el-input-number v-model="form.voice_minute" :max="999999999" step-strictly :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการเสียง (วินาที)">
                            <el-input-number v-model="form.voice_second" :max="999999999" step-strictly :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="โทรไม่จำกัด (Unlimited)">
                            <el-radio-group v-model="form.voice_unlimited" size="small">
                              <el-radio :label="1">ใช่</el-radio>
                              <el-radio :label="0">ไม่ใช่</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                          <div class="col-sm-12">
                            <el-form-item label="เงื่อนไข (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.voice_remark_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-sm-12">
                            <el-form-item label="เงื่อนไข (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.voice_remark_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        <br>
                        <div class="col-sm-6">
                          <el-form-item label="บริการ SMS (ข้อความ)">
                            <el-input-number v-model="form.sms_amount" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="บริการ MMS (ข้อความ)">
                            <el-input-number v-model="form.mms_amount" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <br>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet (MB)">
                            <el-input-number v-model="form.internet_MB" :precision="2" :max="999999999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet (GB)">
                            <el-input-number v-model="form.internet_GB" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet ไม่จำกัด (Unlimited)">
                            <el-radio-group v-model="form.internet_unlimited" size="small">
                              <el-radio :label="1">ใช่</el-radio>
                              <el-radio :label="0">ไม่ใช่</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                          <div class="col-sm-12">
                            <el-form-item label="เงื่อนไข (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.internet_remark_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-sm-12">
                            <el-form-item label="เงื่อนไข (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.internet_remark_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        <br>
                        <div class="col-sm-6">
                          <el-form-item label="ความเร็ว (Kbps)">
                            <el-input-number v-model="form.internet_speed_Kbps" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ความเร็ว (Mbps)">
                            <el-input-number v-model="form.internet_speed_Mbps" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                          <div class="col-sm-12">
                            <el-form-item label="เงื่อนไข (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.internet_speed_remark_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-sm-12">
                            <el-form-item label="เงื่อนไข (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.internet_speed_remark_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        <br>
                          <div class="col-sm-12">
                            <el-form-item label="WiFi คำอธิบาย (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.wifi_service_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-sm-12">
                            <el-form-item label="WiFi คำอธิบาย (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.wifi_service_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        <br>
                          <div class="col-sm-12">
                            <el-form-item label="Others คำอธิบาย (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.other_service_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-sm-12">
                            <el-form-item label="Others คำอธิบาย (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.other_service_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin-top: 12px;margin-bottom: 12px;float: left;"
                            @click="back"
                          >
                            <i class="el-icon-back"></i>ย้อนกลับ
                          </button>
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin-top: 12px;margin-bottom: 12px;float: right;"
                            @click="next"
                          >
                            ขั้นตอนถัดไป
                            <i class="el-icon-right"></i>
                          </button>
                      </div>

                      <div v-if="active===3" class="col-sm-12">
                        <el-form-item label="อัตราค่าบริการเฉลี่ย (ทั้ง Postpaid และ Prepaid)"></el-form-item>
                        <div class="col-sm-6">
                          <el-form-item label="บริการเสียง (บาท/นาที)">
                            <el-input-number v-model="form.voice_per_minute" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="บริการเสียง (บาท/วินาที)">
                            <el-input-number v-model="form.voice_per_second" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                            <el-form-item label="เงื่อนไขอื่น ๆ">
                              <el-input
                                clearable
                                v-model="form.voice_remark"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ SMS (บาท/ข้อความ)">
                            <el-input-number v-model="form.sms_per_message" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ MMS (บาท/ข้อความ)">
                            <el-input-number v-model="form.mms_per_message" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet (บาท/MB)">
                            <el-input-number v-model="form.internet_per_MB" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>

                          <div class="col-sm-12">
                            <el-form-item label="WiFi (คำอธิบาย)">
                              <el-input clearable v-model="form.wifi_average" show-word-limit maxlength="500" type="textarea" :rows="3"></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-sm-12">
                            <el-form-item label="Others (คำอธิบาย)">
                              <el-input clearable v-model="form.other_average" show-word-limit maxlength="500" type="textarea" :rows="3"></el-input>
                            </el-form-item>
                          </div>

                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                      <div v-if="active===4" class="col-sm-12">
                        <el-form-item
                          label="อัตราค่าบริการต่อหน่วยในส่วนที่เกินกว่าสิทธิการใช้งานของแต่ละประเภทบริการ (เฉพาะ Postpaid)"
                        ></el-form-item>
                          <el-form-item label="อัตราค่าบริการเสียง"></el-form-item>
                          <div class="row">
                            <div class="col-sm-6">
                              <el-form-item label="นาทีใด ๆ สูงสุด (บาท/นาที)">
                                <el-input-number v-model="form.average_voice_service" :precision="10" :max="999.9999999999" :min="null" style="width: 400px"></el-input-number>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <el-form-item label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาไทย)">
                                <el-input
                                  clearable
                                  show-word-limit
                                  maxlength="500"
                                  v-model="form.average_voice_remark_th"
                                  type="textarea"
                                  :rows="3"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <el-form-item label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาอังกฤษ)">
                                <el-input
                                  clearable
                                  v-model="form.average_voice_remark_en"
                                  show-word-limit
                                  maxlength="500"
                                  type="textarea"
                                  :rows="3"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        <br>
                          <div class="row">
                            <div class="col-sm-12">
                              <el-form-item label="ค่าบริการด้านข้อมูล"></el-form-item>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-4">
                              <el-form-item label="ค่าบริการ SMS (บาท/ข้อความ)">
                                <el-input-number v-model="form.average_sms_service" :precision="10" :max="999.9999999999" :min="null" style="width: 100%"></el-input-number>
                              </el-form-item>
                            </div>
                            <div class="col-sm-4">
                              <el-form-item label="ค่าบริการ MMS (บาท/ข้อความ)">
                                <el-input-number v-model="form.average_mms_service" :precision="10" :max="999.9999999999" :min="null" style="width: 100%"></el-input-number>
                              </el-form-item>
                            </div>
                            <div class="col-sm-4">
                              <el-form-item label="บริการอินเทอร์เน็ต (บาท/MB)">
                                <el-input-number v-model="form.average_internet_service" :precision="10" :max="999.9999999999" :min="null" style="width: 100%"></el-input-number>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <el-form-item label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาไทย)">
                                <el-input
                                  clearable
                                  v-model="form.average_other_service_th"
                                  show-word-limit
                                  maxlength="500"
                                  type="textarea"
                                  :rows="3"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <el-form-item label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาอังกฤษ)">
                                <el-input
                                  clearable
                                  v-model="form.average_other_service_en"
                                  show-word-limit
                                  maxlength="500"
                                  type="textarea"
                                  :rows="3"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>

                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                      <div v-if="active===5" class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="รูปแบบการคิดค่าบริการประเภทเสียง (วินาที/นาที)" required>
                              <el-select v-model="form.service_charge_type" filterable >
                                <el-option label="Minute" value="Minute"></el-option>
                                <el-option label="Second" value="Second"></el-option>
                                <el-option label="ไม่ระบุ" :value="null"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)">
                              <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 4}"
                                v-model="form.promotion_condition_th"
                                show-word-limit
                                maxlength="500"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)">
                              <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 4}"
                                v-model="form.promotion_condition_en"
                                show-word-limit
                                maxlength="500"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>

                        <!-- <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="addPromotion(form)"
                        >xxxx</button> -->
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                      <div v-if="active===6" class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item
                              label="สิทธิพิเศษ (ที่ไม่มีค่าใช้บริการ)"
                              show-word-limit
                              maxlength="200"
                            ></el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item
                              label="ให้บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง) (ภาษาไทย)"
                            >
                              <el-input
                                clearable
                                v-model="form.privilege_content_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item
                              label="ให้บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง) (ภาษาอังกฤษ)"
                            >
                              <el-input
                                clearable
                                v-model="form.privilege_content_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ให้บริการโซเชียลมีเดีย (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.privilege_social_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ให้บริการโซเชียลมีเดีย (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.privilege_social_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ให้บริการเกม (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.privilege_game_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ให้บริการเกม (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.privilege_game_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="พรีเมี่ยม (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.privilege_premium_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="พรีเมี่ยม (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.privilege_premium_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="อุปกรณ์อื่น ๆ (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.privilege_device_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="อุปกรณ์อื่น ๆ (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.privilege_device_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ให้บริการอื่น ๆ (ภาษาไทย)">
                              <el-input
                                clearable
                                v-model="form.privilege_other_th"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ให้บริการอื่น ๆ (ภาษาอังกฤษ)">
                              <el-input
                                clearable
                                v-model="form.privilege_other_en"
                                show-word-limit
                                maxlength="500"
                                type="textarea"
                                :rows="3"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>

                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                      <div v-if="active===7" class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ย่านคลื่นความถี่"></el-form-item>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="กรุณาเลือกย่านความถี่ที่ให้บริการ (เลือกได้มากกว่า 1 ย่านความถี่)" required>
                            <el-checkbox-group v-model="form.signal_list">
                              <el-checkbox label="900">900 MHz</el-checkbox><br/>
                              <el-checkbox label="1800">1800 MHz</el-checkbox><br/>
                              <el-checkbox label="2100">2.1 GHz</el-checkbox><br/>
                              <el-checkbox label="other">อื่นๆ</el-checkbox><br/>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>

                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                      <div v-if="active===8" class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item
                              label="ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ"
                            >
                              <el-input clearable v-model="form.promotion_link_url" type="textarea" :rows="5"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย">
                              <el-input clearable v-model="form.promotion_ussd" ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-form-item label="ลิงก์รูปโฆษณา หรือรายการส่งเสริมการขาย">
                              <el-input clearable v-model="form.promotion_banner" type="textarea" :rows="5"></el-input>
                            </el-form-item>
                          </div>
                        </div>

                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>
                        <button
                          :disabled="btn_disable"
                          type="button"
                          class="btn btn-success"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="sendForm"
                        >บันทึก</button>
                      </div>
                    </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<style>
  .btn-step :hover {
    cursor: pointer;
    color:#3c8dbc !important
  }
</style>
<script>
const moment = require("moment");
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      editStatus: false,
      label_position: "top",
      active: 0,
      form: {
        promotion_code: "",
        promotion_name_th: "",
        promotion_name_en: "",
        promotion_category: "",
        promotion_type: "",
        number_of_service_days: "",
        start_sale_date: "",
        end_sale_date: "",
        start_sale_date: "",
        end_service_date: "",
        service_status: "",
        promotion_price: "",
        voice_service: "",
        sms_service: "",
        mms_service: "",
        internet_service: "",
        wifi_service: "",
        other_service: "",
        voice_minute: "",
        voice_second: "",
        voice_unlimited: 0,
        voice_remark_th: "",
        voice_remark_en: "",
        sms_amount: "",
        mms_amount: "",
        internet_MB: "",
        internet_GB: "",
        internet_unlimited: 0,
        internet_remark_th: "",
        internet_remark_en: "",
        internet_speed_Kbps: "",
        internet_speed_Mbps: "",
        internet_speed_remark_th: "",
        internet_speed_remark_en: "",
        wifi_service_th: "",
        wifi_service_en: "",
        other_service_th: "",
        other_service_en: "",
        voice_per_minute: "",
        voice_per_second: "",
        voice_remark: "",
        sms_per_message: "",
        mms_per_message: "",
        internet_per_MB: "",
        wifi_average: "",
        other_average: "",
        average_voice_service: "",
        average_voice_remark_th: "",
        average_voice_remark_en: "",
        average_sms_service: "",
        average_mms_service: "",
        average_internet_service: "",
        average_other_service_th: "",
        average_other_service_en: "",
        service_charge_type: null,
        promotion_condition_th: "",
        promotion_condition_en: "",
        privilege_content_th: "",
        privilege_content_en: "",
        privilege_social_th: "",
        privilege_social_en: "",
        privilege_game_th: "",
        privilege_game_en: "",
        privilege_premium_th: "",
        privilege_premium_en: "",
        privilege_device_th: "",
        privilege_device_en: "",
        privilege_other_th: "",
        privilege_other_en: "",
        signal_900: "",
        signal_1800: "",
        signal_2100: "",
        signal_other: "",
        signal_list: [],
        promotion_link_url: "",
        promotion_ussd: "",
        promotion_banner: "",
        type_form:'add'
      }
    };
  },
  computed: {
    ...mapState({
      btn_disable : store => store.Promotion.btn_disable,
      monthly_regulate : store => store.Promotion.monthly
    })
  },
  created(){
    if(!this.monthly_regulate) this.$router.push({ name: 'Manage_mobileOperator' })
    this.$store.commit('Promotion/BTN_DISABLE', false)
  },
  methods: {
    ...mapActions({
      addPromotion: "Promotion/addPromotion"
    }),
    sendForm(){
      let temp_form = this.form
          temp_form.signal_900 = temp_form.signal_list.includes('900') ? 1 : 0
          temp_form.signal_1800 = temp_form.signal_list.includes('1800') ? 1 : 0
          temp_form.signal_2100 = temp_form.signal_list.includes('2100') ? 1 : 0
          temp_form.signal_other = temp_form.signal_list.includes('other') ? 1 : 0
          temp_form.monthly_regulate = this.monthly_regulate
      this.addPromotion(temp_form)
    },
    next() {
      if(this.validate(this.active)){
        this.active++;
      }
    },
    back() {
      this.active--;
    },
    validate: function(page){
      let pass = false;
      switch (page) {
        case 0:
          if(this.form.promotion_code == '') {
            this.$confirm("กรุณากรอกรหัสรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_name_th == '') {
            this.$confirm("กรุณากรอกชื่อรายการส่งเสริมการขาย (ภาษาไทย)", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_category == '') {
            this.$confirm("กรุณาเลือกประเภทบริการของรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_type == '') {
            this.$confirm("กรุณาเลือกชนิดของรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.start_sale_date == '') || (this.form.start_sale_date == null)) {
            this.$confirm("กรุณาเลือกวันเริ่มต้นของการเสนอขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.end_sale_date != '') && (this.form.start_sale_date >= this.form.end_sale_date)) {
            this.$confirm("วันสิ้นสุดการเสนอขาย ต้องมากกว่าวันเริ่มต้นการเสนอขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.start_service_date == '') || (this.form.start_service_date == null)) {
            this.$confirm("กรุณาเลือกวันเริ่มต้นของการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.end_service_date != '') && (this.form.start_sale_date >= this.form.end_service_date)) {
            this.$confirm("วันสิ้นสุดการให้บริการ ต้องมากกว่าวันเริ่มต้นการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(!this.form.service_status) {
            this.$confirm("กรุณาเลือกสถานะการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else {
            pass = true;
          }
          break;
        case 1:
          pass = true;
          break;
        case 2:
          pass = true;
          break;
        case 3:
          pass = true;
          break;
        case 4:
          pass = true;
          break;
        case 5:
          if(this.form.service_charge_type == '') {
            this.$confirm("กรุณาเลือกรูปแบบการคิดค่าบริการประเภทเสียง (วินาที/นาที)", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          }
          pass = true;
          break;
        case 6:
          pass = true;
          break;
        case 7:
          if (this.form.signal_list.length == 0) {
            this.$confirm("กรุณาเลือกย่านคลื่นความถี่ อย่างน้อย 1 ย่านความถี่", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
          } else {
            pass = true
          }
          break;
        case 8:
          pass = true;
          break;
        default:
          return false
      }
      return pass
    },
    pickType(){
      this.form.number_of_service_days = ''
    },
    steps(number){
      let temp = this.active
      let going_page = number
      if (temp < number){
        for(let page = temp; page < number; page++){
          if(!this.validate(page)) {
            going_page = page
            break;
          }
        }
        this.active = going_page
      } else {
        this.active = going_page
      }
    }
  }
};
</script>
